import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import StudentContactRelationshipViewModel from '../ViewModels/StudentContactRelationshipViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IStudentRelationshipDropDownProps {
    setStudentRelationship?: (event) => void;
    studentRelationship: number | undefined;
    disabled: boolean;
    propName: string;
    label: string;
    enrolmentConfirmationMode: boolean | undefined;
    required: boolean;
    childMode: boolean | undefined;
}

interface IStudentRelationshipDropDownState {
    model: StudentContactRelationshipViewModel[];
    loaded: boolean;
}

class StudentRelationshipDropDown extends Component<IStudentRelationshipDropDownProps & WithStyles<typeof styles>, IStudentRelationshipDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetStudentRelationships?enrolmentConfirmationMode=' + (this.props.enrolmentConfirmationMode === undefined ? false : this.props.enrolmentConfirmationMode) + '&childMode=' + (this.props.childMode !== undefined ? this.props.childMode : false)).then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            
            items = this.state.model.map(item =>
                <MenuItem key={item.studentContactRelationshipID} value={item.studentContactRelationshipID}>{item.description}</MenuItem>
            );

            if (this.props.required === false) {
                items.push(<MenuItem key="defaultStudentRelationshipVal" value=''>Not Set</MenuItem>);
            }
        }

        return (
            <SelectValidator
                label={this.props.label}
                name={this.props.propName}
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.studentRelationship}
                onChange={this.props.disabled ? undefined : this.props.setStudentRelationship}
                disabled={this.props.disabled}
                validators={this.props.required ? ['required'] : undefined}
                errorMessages={this.props.required ? ['This field is required'] : undefined}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(StudentRelationshipDropDown);